import { defineStore } from 'pinia'
import { fetchApp } from '@app/api'
import { setPendo } from '@lib/pendo'
import { setKoala } from '@lib/koala'
import { useUserStore } from '@app/stores/UserStore'

export const useAccountStore = defineStore('AccountStore', {
  state: () => {
    return {
      account: null,
      user: null,
      true_user: null,
    }
  },
  actions: {
    getApp() {
      return fetchApp().then((response) => {
        // user is the currently logged in user
        this.user = response.data.user

        // true_user is the impersonated user
        this.true_user = response.data.true_user

        this.account = response.data.account

        useUserStore().setUser(this.user)
        useUserStore().setTrueUser(this.true_user)

        if (process.env.NODE_ENV === 'production') {
          setPendo(this.account, this.user)
          setKoala(this.account, this.user)
        }

        return {
          account: this.account,
          user: this.user,
          true_user: this.true_user,
        }
      })
    },

    /**
     * Generates a unique state parameter for Slack OAuth
     * Uses account ID + random string + timestamp to ensure uniqueness
     * @returns {string} A unique state parameter for Slack OAuth
     */
    generateSlackState() {
      if (!this.account || !this.account.id) {
        return null
      }

      // Create a unique string using account ID, random string and timestamp
      const randomStr = Math.random().toString(36).substring(2, 15)
      const timestamp = new Date().getTime()
      return `ue-${this.account.id}-${randomStr}-${timestamp}`
    },
  },
})
